function i(e, s = [], c) {
  const n = {};
  return Object.getOwnPropertyNames(e).forEach((t) => {
    s.includes(t) || (n[t] = e[t]);
  }), Object.assign(n, c);
}
export {
  i as omit
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/omit.js
// module id = 311
// module chunks = 41